export function sendToGA(eventName, attrs = {}) {
  if (!window.gtag) return
  switch (eventName) {
    case 'ACCOUNT_CREATED':
      logAccountCreated(eventName, attrs)
      break
    case 'ACCOUNT_ONBOARDING_FINISHED':
      logAccountOnboardingFinished(eventName, attrs)
      break
    default:
      return
  }
}

function logAccountCreated(eventName, attrs) {
  let params = {
    app_name: attrs.app_name,
    env: attrs.env,
    log_type: attrs.context.log_type,
    institution: attrs.context.institution,
    user_type: attrs.context.client_type,
    demand: attrs.context.demand,
    demand_type: attrs.context.demand_type,
    demand_detail: attrs.context.demand_detail,
    subscription_code: attrs.context.subscription_code,
    subscription_code_type: attrs.context.subscription_code_type
  }
  window.gtag('event', eventName, params)
}

function logAccountOnboardingFinished(eventName, attrs) {
  const params = {
    app_name: attrs.app_name,
    env: attrs.env,
    log_type: attrs.context.log_type,
    institution: attrs.context.institution,
    user_type: attrs.context.client_type
  }
  window.gtag('event', eventName, params)
}
